import {useContext} from 'react';
import {RouteComponentProps} from 'react-router-dom';
import {__RouterContext} from 'react-router';

export default function useRouter<TParams = {}>() {
  return useContext(__RouterContext) as RouteComponentProps<TParams>;
}
